var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThankyoupagemobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141.845,
    height: 141.646,
    viewBox: "0 0 141.845 141.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_369",
    x: 0,
    y: 0,
    width: 141.845,
    height: 141.646,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 14,
    dy: 14,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(-6095 -12136.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6095, 12136)",
    filter: "url(#Path_369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369-2",
    "data-name": "Path 369",
    d: "M190.529,114.442c-13.424,9-33.232,30.384-41.028,47.172-6.411-9.09-12.341-17.143-21.668-24.758-4.5-3.671-10.039,3.124-5.545,6.793,10.081,8.231,17.535,16.209,23.891,26.108a4.545,4.545,0,0,0,8.008-.688c6.712-15.876,23.726-38.259,36.245-48.77h0A46.5,46.5,0,1,1,110.2,167.315c-17.9-31,4.475-69.752,40.271-69.752a45.861,45.861,0,0,1,30.555,11.393,1.643,1.643,0,0,0,2.288-.112l.023-.025a1.646,1.646,0,0,0-.113-2.358,49.175,49.175,0,0,0-33.426-12.216c-38.232.483-61.592,41.618-42.474,74.731,19.177,33.215,67.119,33.214,86.3,0A49.51,49.51,0,0,0,190.529,114.442Z",
    transform: "translate(-93.51 -87.24)",
    fill: "#ecf1f2"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyoupagemobile);
export default __webpack_public_path__ + "static/media/Thankyou page mobile.3c61305cb16e3d685103eca5e3bdc454.svg";
export { ForwardRef as ReactComponent };